import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/gua";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-sm"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-water-flash-line text-lg"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            吃瓜<span className="text-primary-500">中心</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#feed"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            去看瓜
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-center text-sm font-medium text-background-50"
            >
              订阅吃瓜晚报
            </a>
          </div>
        </div>
      )}
    </header>
  );
}